export default __webpack_public_path__ + "static/media/email_image.fe86f748.svg";